import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/initialPage/exit.svg'


const _hoisted_1 = { class: "menu" }
const _hoisted_2 = {
  key: 0,
  class: "icons"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user_info" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "email" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuOptions = _resolveComponent("MenuOptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$store.getters.getSignedIn && _ctx.$store.getters.getSignedIn != false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.cImage,
            alt: "",
            class: "avatar"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.name), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.user.email), 1)
          ]),
          _createElementVNode("img", {
            class: "menu_icon",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSignOut()))
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MenuOptions)
  ]))
}